<template>
        <div>
            <div class="text-left">
                <h3 class="mb-3">{{$t('cal_Pip_Value')}}</h3>
                <p>{{$t('cal_Pip_txt')}}</p>
            </div>
            <div class="verticallyTab mt-5">
				<p v-if="message != ''" style="color:red">{{message}}</p>
                <div class="bottomTab">
                    <div class="stepForm-contact mt-5">
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <div class="form-group field-wrapper">
                                    <select class="selectpicker float-field form-control" @change="currencyList()" v-model="segm" v-validate="'required'" name="segm" :class="{ 'is-invalid': submitted && errors.has('segm'), 'active' : segm != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                        <!-- <option value=""></option> -->
                                        <option value="Forex">{{$t('cal_marg_forex')}}</option>
                                        <option value="Commodities">{{$t('cal_marg_commodities')}}</option>
                                        <option value="INDICIES">{{$t('cal_marg_indices')}}</option>
                                        <!--<option>Crypto</option>-->
                                    </select>
                                    <label class="float-label">Asset Class</label>
									<p class="error" v-if="submitted" v-for="error in errors.collect('segm')">{{$t('cal_Pip_Field_req')}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form-group field-wrapper">
                                    <select class="selectpicker float-field form-control" v-model="basecurreny" name="basecurreny" v-validate="'required'"  :class="{ 'is-invalid': submitted && errors.has('basecurreny'), 'active' : basecurreny != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                        <!-- <option value=""></option> -->
                                        <option value="USD">{{$t('cal_comm_USD')}}</option>
                                        <option value="GBP">{{$t('cal_comm_GBP')}}</option>
                                        <option value="AUD">{{$t('cal_comm_AUD')}}</option>
                                        <option value="EUR">{{$t('cal_comm_EUR')}}</option>
                                    </select>
                                    <label class="float-label">{{$t('cal_Pip_accBaseCurr')}}</label>
									<p class="error" v-if="submitted" v-for="error in errors.collect('basecurreny')">{{$t('cal_Pip_Field_req')}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form-group field-wrapper">
                                    <select class="selectpicker float-field form-control" v-model="selectedSymbol" name="selectedSymbol" v-validate="'required'"  :class="{ 'is-invalid': submitted && errors.has('selectedSymbol'), 'active' : selectedSymbol != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                        <!-- <option value=""></option> -->
                                       <option v-for="spreads in isins" :value="spreads">{{spreads}}</option>
                                    </select>
                                    <label class="float-label">{{$t('cal_Pip_Symbol')}}</label>
									<p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbol')">{{$t('cal_Pip_Field_req')}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form-group field-wrapper">
                                    <input type="text" v-model="tradesize" class="float-field form-control" name="tradesize" v-validate="{ required: true,decimal:5}"  :class="{ 'is-invalid': submitted && errors.has('tradesize') }">
                                    <label class="float-label" style="text-transform: none !important;">{{$t('cal_Pip_trade_size_lot')}}</label>
									<p class="error" v-if="submitted" v-for="error in errors.collect('tradesize')">{{$t('cal_Pip_Field_req')}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <div class="form-group field-wrapper">
                                    <a href="#" class="common_btn" v-on:click.prevent="calculatePip()">{{$t('cal_Pip_Now')}}</a>
                                    <p class="mt-3">{{$t('cal_Pip_Value')}}: {{basecurreny}} {{pip}}</p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
    
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'PIP',
        mixins: [fxViewMixins],
        data() {
            return {
                "isins":'',
                "segm": 'Forex',
                "tradesize": 0,
                "selectedSymbol":"",
                "selectedSeg":"",
                "commission": 0,
                "basecurreny":'USD',
                "orderType": "B",
                "pip":0,
                "openPrice":"",
                "closePrice":"",
				submitted : false,
				message : '',
                allIsins:''
            }
        },
        methods:{
            currencyList(){
                this.isinList=""
                this.allIsins = this.$store.getters['/GET_ISINS_LIST'];
                this.isins = Object.keys(this.allIsins).filter(key => this.allIsins[key].type === this.segm);
                return this.isins;
            },
            calculatePip(){
				const _that = this
                this.submitted = true;
				this.message = ''
                this.$validator.validate().then(valid => {
                    if (valid) {
                        const _that=this
						let pipCal=''
                        let selectedCurrecy= this.allIsins[_that.selectedSymbol]
                        let fetchedSelectedSymbol= ''
                        let priceFeed= this.$store.getters['/GET_PRICEFEED_DATA'];
                        let firstCurrency=''
                        const match = _that.selectedSymbol.match(/\((.*?)\)/); // Regex to find text within brackets
                        if (match) {
                            fetchedSelectedSymbol = match[0]; // Get the content inside the brackets
                        }else {
                            fetchedSelectedSymbol = _that.selectedSymbol; // No brackets found
                        }          
                        let selectedIsinPrice= priceFeed[fetchedSelectedSymbol]
                        pipCal= selectedCurrecy.pip_size*selectedIsinPrice.A*_that.tradesize
                        if(_that.segm=='Shares'){
                            firstCurrency="USD"
                        }else{
                            if(_that.selectedSymbol.includes('.') || _that.selectedSymbol.includes('(')){
                            if(_that.selectedSymbol.includes('.')){
                                let lastSymbol=_that.selectedSymbol.trim('.')
                                firstCurrency = lastSymbol.slice('3','6')
                            }else if(_that.selectedSymbol.includes('(')){
                                let lastSymbol=_that.selectedSymbol.split('(')[0]
                                firstCurrency = lastSymbol.slice('3','6')
                            }
                            }else if(_that.selectedSymbol.includes('-')){
                            let lastSymbol=_that.selectedSymbol.replace('-', '')
                            firstCurrency = lastSymbol.slice('3','6')
                            }else{                            
                            firstCurrency = _that.selectedSymbol.slice('3','6')
                            }
                        }
                        if(firstCurrency == _that.basecurreny){
                            let secCurrencyPrice = 1
                            this.pip= pipCal*secCurrencyPrice
                        }else{
                                let secondaryCurrencyPrice = priceFeed[firstCurrency+_that.basecurreny]
                            if(secondaryCurrencyPrice){
                                this.pip = secondaryCurrencyPrice.A*pipCal
                            }else if(priceFeed[_that.basecurreny+firstCurrency]){
                                secondaryCurrencyPrice = priceFeed[_that.basecurreny+firstCurrency]
                                this.pip = (1/secondaryCurrencyPrice.A)*pipCal
                            }else{     
                                let allIsinList = []
                                let filteredIsins=[]
                                let secondPrice=''
                                allIsinList= Object.keys(this.allIsins)
                                filteredIsins = allIsinList.filter(val=>val.includes(firstCurrency)&&val.includes("USD"))
                                let filteredIsinsSecond=[]
                                filteredIsinsSecond = allIsinList.filter(val=>val.includes(_that.basecurreny))
                                let filteredIsinsSecondPrice= priceFeed[filteredIsinsSecond[0]]
                                secondPrice= 1/filteredIsinsSecondPrice.A
                                filteredIsins.forEach(val=>{
                                    if(val.slice(0,3)=='USD'){
                                        let price= priceFeed['USD'+firstCurrency]
                                        this.pip= (price.A*secondPrice)*pipCal
                                    }else if(val.slice(3,6)){
                                        let price= priceFeed[firstCurrency+'USD']
                                        this.pip= (price.A*secondPrice)*pipCal
                                    }
                                })
                            }
                        }
					}
				})
            }
        },
        created(){
            this.currencyList()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/pip_value.vue